import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {NavService} from '../../../shared/service/nav.service';
import {CreatorService} from '../../../shared/service/creator.service';

export type ProfileTab = 'profile' | 'classes' | 'attendance' | 'reports' | 'curriculum' | 'communications';
export type ProfileInfoSubTab = 'personal' | 'parent';

export interface CurriculumItem {
    id: string;
    class_id: string;
    class_name: string;
    content_name: string;
    content_format: string;
    content_type: 'Assignment' | 'Assessment' | 'Resource';
    start_date: string;
    end_date: string;
    completed: boolean;
    score?: string;
    total_score?: string;
    percentage?: string;
}

@Component({
    selector: 'app-student-overall-profile-details-new',
    templateUrl: './student-overall-profile-details-new.component.html',
    styleUrls: ['./student-overall-profile-details-new.component.scss']
})
export class StudentOverallProfileDetailsNewComponent implements OnInit, OnDestroy {

    activeTab: ProfileTab = 'profile';
    profileSubTab: ProfileInfoSubTab = 'personal';
    selectedParent = 1;

    readonly demoBanner = 'Demo / discussion prototype — dummy data only';

    readonly studentProfile = {
        first_name: 'Hema',
        last_name: 'Test',
        email_id: 'hemaramesh93@gmail.com',
        gender: 'Female',
        birthday: '12/15/2021',
        grade_name: '5',
        school_idno: '-',
        mobile: ['7200284897', '', ''],
        status: 'Active',
        registration_date: '11/17/2021',
        profile_photo: 'Available'
    };

    readonly parent1 = {
        first_name: 'Ccccccc',
        last_name: '-',
        email_ids: ['parent10@gmail.com', '-'],
        address1: 'Vvvvvvv',
        address2: 'Bbbbbb',
        city: 'Mmmmm',
        state_name: '-',
        country_name: '-',
        postal_code: '-'
    };

    readonly parent2 = {
        first_name: '-',
        last_name: '-',
        email_ids: ['-', '-'],
        address1: '-',
        address2: '-',
        city: '-',
        state_name: '-',
        country_name: '-',
        postal_code: '-'
    };

    readonly classList = [
        {
            class_name: 'Online - Tuesday - 6PM to 7PM - Grade 5 Prep',
            class_code: 'AOUIMBFDWY',
            subject: 'Math',
            grade: '5',
            start_date: '08/24/2025',
            end_date: '06/28/2026',
            joining_date: '08/24/2025',
            drafted_date: '-',
            notify_status: 'No'
        },
        {
            class_name: 'South Plainfield-Friday-5PM to 6PM-Gr 6 RW',
            class_code: 'SRHEHDFXBDB',
            subject: 'Reading & Writing',
            grade: '6',
            start_date: '08/24/2025',
            end_date: '06/28/2026',
            joining_date: '08/24/2025',
            drafted_date: '-',
            notify_status: 'Yes'
        },
        {
            class_name: 'hema essay',
            class_code: 'HEMAESSAY01',
            subject: 'Writing',
            grade: '5',
            start_date: '01/15/2025',
            end_date: '12/31/2025',
            joining_date: '01/15/2025',
            drafted_date: '-',
            notify_status: 'No'
        }
    ];

    classFilterOptions = [
        {class_id: '', class_name: 'All Class'},
        {class_id: '1', class_name: 'Online - Tuesday - 6PM to 7PM - Grade 5 Prep'},
        {class_id: '2', class_name: 'hema essay'},
        {class_id: '3', class_name: 'South Plainfield-Friday-5PM to 6PM-Gr 6 RW'}
    ];
    selectedClassId = '';
    selectedCurriculumClassId = '';
    curriculumContentTypeFilter = 'All';

    readonly curriculumContentTypeOptions = [
        {value: 'All', label: 'All'},
        {value: 'Resource', label: 'Resource'},
        {value: 'Assignment', label: 'Assignment'},
        {value: 'Assessment', label: 'Assessment'}
    ];

    readonly allAttendance = [
        {class_name: 'hema essay', date: '08/05/2025', start_time: '12:00 AM', end_time: '11:59 PM', attendance: '0', makeup: ''},
        {class_name: 'hema essay', date: '08/12/2025', start_time: '12:00 AM', end_time: '11:59 PM', attendance: '1', makeup: ''},
        {class_name: 'Online - Tuesday - 6PM to 7PM - Grade 5 Prep', date: '08/06/2025', start_time: '6:00 PM', end_time: '7:00 PM', attendance: '1', makeup: ''},
        {class_name: 'Online - Tuesday - 6PM to 7PM - Grade 5 Prep', date: '08/13/2025', start_time: '6:00 PM', end_time: '7:00 PM', attendance: '0', makeup: 'Make-up scheduled 08/20/2025'},
        {class_name: 'South Plainfield-Friday-5PM to 6PM-Gr 6 RW', date: '08/08/2025', start_time: '5:00 PM', end_time: '6:00 PM', attendance: '1', makeup: ''},
        {class_name: 'South Plainfield-Friday-5PM to 6PM-Gr 6 RW', date: '08/15/2025', start_time: '5:00 PM', end_time: '6:00 PM', attendance: '1', makeup: ''}
    ];
    attendanceListData = [...this.allAttendance];

    selectedReportsClassId = '';

    readonly allReports = [
        {report_name: 'Math Grade 5 — Mid-Term Progress', class_id: '1', class_name: 'Online - Tuesday - 6PM to 7PM - Grade 5 Prep', generated_date: '03/15/2026', score: '82%', status: 'Published'},
        {report_name: 'Reading & Writing — Quarterly Summary', class_id: '3', class_name: 'South Plainfield-Friday-5PM to 6PM-Gr 6 RW', generated_date: '03/01/2026', score: '91%', status: 'Published'},
        {report_name: 'Essay Workshop — Draft Review', class_id: '2', class_name: 'hema essay', generated_date: '02/28/2026', score: '74%', status: 'Draft'},
        {report_name: 'Attendance Summary — February 2026', class_id: '', class_name: 'All Classes', generated_date: '02/25/2026', score: '88% present', status: 'Published'}
    ];
    reportsListData = [...this.allReports];

    readonly allCurriculum: CurriculumItem[] = [
        {id: '1', class_id: '1', class_name: 'Online - Tuesday - 6PM to 7PM - Grade 5 Prep', content_name: 'Lesson 13_Counting_and_Probability_Classwork_SE', content_format: 'PDF', content_type: 'Assignment', start_date: '05/04/2026', end_date: '09/01/2026', completed: false},
        {id: '2', class_id: '1', class_name: 'Online - Tuesday - 6PM to 7PM - Grade 5 Prep', content_name: 'Lesson 14_Algebra_Introduction_HW', content_format: 'PDF', content_type: 'Assignment', start_date: '05/11/2026', end_date: '09/08/2026', completed: false},
        {id: '3', class_id: '1', class_name: 'Online - Tuesday - 6PM to 7PM - Grade 5 Prep', content_name: 'Lesson 15_Midterm_Math_Assessment', content_format: 'PDF', content_type: 'Assessment', start_date: '05/18/2026', end_date: '06/01/2026', completed: true, score: '42', total_score: '50', percentage: '84%'},
        {id: '4', class_id: '2', class_name: 'hema essay', content_name: 'Lesson 10_Personal_Narrative_Draft', content_format: 'PDF', content_type: 'Assignment', start_date: '04/20/2026', end_date: '08/15/2026', completed: true},
        {id: '5', class_id: '2', class_name: 'hema essay', content_name: 'Lesson 11_Essay_Peer_Review_Assessment', content_format: 'PDF', content_type: 'Assessment', start_date: '04/27/2026', end_date: '05/10/2026', completed: true, score: '38', total_score: '40', percentage: '95%'},
        {id: '6', class_id: '3', class_name: 'South Plainfield-Friday-5PM to 6PM-Gr 6 RW', content_name: 'Lesson 08_Reading_Comprehension_Passage', content_format: 'PDF', content_type: 'Assignment', start_date: '05/01/2026', end_date: '09/15/2026', completed: false},
        {id: '7', class_id: '3', class_name: 'South Plainfield-Friday-5PM to 6PM-Gr 6 RW', content_name: 'Lesson 09_RW_Quarterly_Assessment', content_format: 'PDF', content_type: 'Assessment', start_date: '05/25/2026', end_date: '06/08/2026', completed: false},
        {id: '8', class_id: '1', class_name: 'Online - Tuesday - 6PM to 7PM - Grade 5 Prep', content_name: 'Lesson 12_Reference_Sheet_Counting', content_format: 'PDF', content_type: 'Resource', start_date: '04/01/2026', end_date: '09/01/2026', completed: false}
    ];
    curriculumListData: CurriculumItem[] = [...this.allCurriculum];

    readonly communicationsData = [
        {date: '05/20/2026', time: '9:15 AM', subject: 'Class reminder — Tuesday Math session', recipient: 'hemaramesh93@gmail.com', preview: 'Reminder: Online Math class starts at 6:00 PM today.'},
        {date: '05/18/2026', time: '2:40 PM', subject: 'Assignment due — Lesson 13 Classwork', recipient: 'hemaramesh93@gmail.com', preview: 'Your assignment Lesson 13_Counting_and_Probability is due on 09/01/2026.'},
        {date: '05/15/2026', time: '11:05 AM', subject: 'Attendance notice', recipient: 'hemaramesh93@gmail.com', preview: 'You were marked absent for hema essay on 08/05/2025. Schedule a make-up class if needed.'},
        {date: '05/10/2026', time: '4:22 PM', subject: 'Assessment score posted', recipient: 'hemaramesh93@gmail.com', preview: 'Lesson 15 Midterm Math Assessment — Score: 42/50 (84%).'},
        {date: '05/02/2026', time: '8:00 AM', subject: 'Welcome to Grade 5 Prep', recipient: 'hemaramesh93@gmail.com', preview: 'You have been enrolled in Online - Tuesday - 6PM to 7PM - Grade 5 Prep.'}
    ];

    selectedClassForModal: any;
    modalRef: NgbModalRef;

    readonly assignmentLegend = [
        {label: 'UpComing', class: 'yet-to-start-color-bg'},
        {label: 'In Progress', class: 'in-progress-color-bg'},
        {label: 'Completed', class: 'completed-color-bg'},
        {label: 'Pending', class: 'pending-color-bg'},
        {label: 'Overdue', class: 'over-due-bg'},
        {label: 'Not Started', class: 'never-bg'}
    ];

    readonly assignmentDetailsByClass: Record<string, any[]> = {
        'Online - Tuesday - 6PM to 7PM - Grade 5 Prep': [
            {content_name: 'Fractions Practice Set', start_date: '02/01/2026', end_date: '02/15/2026', score: '18', total_score: '20', percentage: '90%', status: 'Completed', statusClass: 'completed-color-bg'},
            {content_name: 'Word Problems — Unit 3', start_date: '02/16/2026', end_date: '03/01/2026', score: '12', total_score: '20', percentage: '60%', status: 'In Progress', statusClass: 'in-progress-color-bg'},
            {content_name: 'Geometry Basics Quiz', start_date: '03/05/2026', end_date: '03/20/2026', score: '-', total_score: '25', percentage: '-', status: 'UpComing', statusClass: 'yet-to-start-color-bg'}
        ],
        'South Plainfield-Friday-5PM to 6PM-Gr 6 RW': [
            {content_name: 'Narrative Essay Draft', start_date: '01/10/2026', end_date: '01/25/2026', score: '45', total_score: '50', percentage: '90%', status: 'Completed', statusClass: 'completed-color-bg'},
            {content_name: 'Reading Comprehension #4', start_date: '02/01/2026', end_date: '02/14/2026', score: '0', total_score: '30', percentage: '0%', status: 'Overdue', statusClass: 'over-due-bg'}
        ],
        'hema essay': [
            {content_name: 'Personal Essay — Outline', start_date: '07/20/2025', end_date: '08/01/2025', score: '8', total_score: '10', percentage: '80%', status: 'Completed', statusClass: 'completed-color-bg'},
            {content_name: 'Personal Essay — Final', start_date: '08/02/2025', end_date: '08/10/2025', score: '-', total_score: '25', percentage: '-', status: 'Pending', statusClass: 'pending-color-bg'}
        ]
    };

    assignmentRows: any[] = [];
    contentTypeFilter = '2';
    searchContent = '';

    readonly curriculumThumb = 'assets/images/ristaschool/option-writing-checkbox-concepts-survey.png';
    readonly profileAvatar = 'assets/images/ristaschool/option-writing-checkbox-concepts-survey.png';

    readonly personalInfoGroups = [
        {
            title: 'Basic Information',
            icon: 'fa-id-card-o',
            fields: [
                {label: 'First Name', valueKey: 'first_name', capitalize: true},
                {label: 'Last Name', valueKey: 'last_name', capitalize: true},
                {label: 'Gender', valueKey: 'gender', capitalize: true},
                {label: 'Date of Birth', valueKey: 'birthday'},
                {label: 'Grade', valueKey: 'grade_name'},
                {label: 'Student ID', valueKey: 'school_idno'}
            ]
        },
        {
            title: 'Contact & Account',
            icon: 'fa-envelope-o',
            fields: [
                {label: 'Email Address', valueKey: 'email_id'},
                {label: 'Contact Number', valueKey: 'mobile0'},
                {label: 'Contact Number 2', valueKey: 'mobile1'},
                {label: 'Contact Number 3', valueKey: 'mobile2'},
                {label: 'Status', valueKey: 'status', highlight: 'success'},
                {label: 'Registration Date', valueKey: 'registration_date'}
            ]
        },
        {
            title: 'Other',
            icon: 'fa-camera',
            fields: [
                {label: 'Profile Photo', valueKey: 'profile_photo'}
            ]
        }
    ];

    @ViewChild('assignmentModal') assignmentModal: TemplateRef<any>;

    constructor(
        private modalService: NgbModal,
        public router: Router,
        public navServices: NavService,
        public creatorService: CreatorService
    ) {}

    ngOnInit(): void {
        this.creatorService.changeViewList(true);
        this.navServices.collapseSidebar = true;
    }

    ngOnDestroy(): void {
        this.creatorService.changeViewList(false);
        this.navServices.collapseSidebar = false;
    }

    get activeParent(): typeof this.parent1 {
        return this.selectedParent === 1 ? this.parent1 : this.parent2;
    }

    setTab(tab: ProfileTab): void {
        this.activeTab = tab;
    }

    setProfileSubTab(tab: ProfileInfoSubTab): void {
        this.profileSubTab = tab;
    }

    parentTabChange(id: number): void {
        this.selectedParent = id;
    }

    getStudentFieldValue(key: string): string {
        const p = this.studentProfile;
        switch (key) {
            case 'mobile0': return p.mobile[0] || '-';
            case 'mobile1': return p.mobile[1] || '-';
            case 'mobile2': return p.mobile[2] || '-';
            default: return (p as any)[key] ?? '-';
        }
    }

    getParentFieldValue(key: string): string {
        const parent = this.activeParent;
        switch (key) {
            case 'email1': return parent.email_ids[0] || '-';
            case 'email2': return parent.email_ids[1] || '-';
            default: return (parent as any)[key] ?? '-';
        }
    }

    readonly parentInfoGroups = [
        {
            title: 'Parent / Guardian',
            icon: 'fa-users',
            fields: [
                {label: 'First Name', key: 'first_name', capitalize: true},
                {label: 'Last Name', key: 'last_name', capitalize: true},
                {label: 'Email Address 1', key: 'email1'},
                {label: 'Email Address 2', key: 'email2'}
            ]
        },
        {
            title: 'Address',
            icon: 'fa-map-marker',
            fields: [
                {label: 'Address 1', key: 'address1', capitalize: true},
                {label: 'Address 2', key: 'address2', capitalize: true},
                {label: 'City', key: 'city', capitalize: true},
                {label: 'State', key: 'state_name', capitalize: true},
                {label: 'Country', key: 'country_name', capitalize: true},
                {label: 'Zip Code', key: 'postal_code'}
            ]
        }
    ];

    backFunction(): void {
        this.router.navigate(['/users/user-list']);
    }

    openLegacyProfile(): void {
        this.router.navigate(['/studentlogin/profile-details']);
    }

    private resolveClassName(classId: string): string | undefined {
        return this.classFilterOptions.find(c => c.class_id === classId)?.class_name;
    }

    attendanceFilter(value: { class_id: string; class_name: string } | string | null): void {
        let classId = '';
        if (value && typeof value === 'object') {
            classId = value.class_id ?? '';
        } else if (typeof value === 'string') {
            classId = value;
        }
        this.selectedClassId = classId;
        if (!classId) {
            this.attendanceListData = [...this.allAttendance];
            return;
        }
        const className = this.resolveClassName(classId);
        this.attendanceListData = this.allAttendance.filter(a => a.class_name === className);
    }

    reportsClassFilter(value: { class_id: string; class_name: string } | string | null): void {
        let classId = '';
        if (value && typeof value === 'object') {
            classId = value.class_id ?? '';
        } else if (typeof value === 'string') {
            classId = value;
        }
        this.selectedReportsClassId = classId;
        if (!classId) {
            this.reportsListData = [...this.allReports];
            return;
        }
        this.reportsListData = this.allReports.filter(
            r => r.class_id === classId || r.class_id === ''
        );
    }

    curriculumClassFilter(value: { class_id: string; class_name: string } | string | null): void {
        let classId = '';
        if (value && typeof value === 'object') {
            classId = value.class_id ?? '';
        } else if (typeof value === 'string') {
            classId = value;
        }
        this.selectedCurriculumClassId = classId;
        this.applyCurriculumFilters();
    }

    onCurriculumContentTypeChange(): void {
        this.applyCurriculumFilters();
    }

    applyCurriculumFilters(): void {
        let list = [...this.allCurriculum];
        if (this.selectedCurriculumClassId) {
            list = list.filter(c => c.class_id === this.selectedCurriculumClassId);
        }
        if (this.curriculumContentTypeFilter !== 'All') {
            list = list.filter(c => c.content_type === this.curriculumContentTypeFilter);
        }
        this.curriculumListData = list;
    }

    curriculumRowAccentClass(item: CurriculumItem): string {
        if (item.content_type === 'Assessment') {
            return 'accent-assessment';
        }
        if (item.content_type === 'Resource') {
            return 'accent-resource';
        }
        return 'accent-assignment';
    }

    curriculumStatusLabel(item: CurriculumItem): string {
        if (item.content_type === 'Resource') {
            return 'Available';
        }
        if (item.content_type === 'Assessment' && item.completed) {
            return 'Completed';
        }
        if (item.content_type === 'Assessment') {
            return 'Pending';
        }
        return item.completed ? 'Submitted' : 'In progress';
    }

    contentTypeBadgeClass(type: string): string {
        if (type === 'Assessment') {
            return 'badge-primary';
        }
        if (type === 'Resource') {
            return 'badge-green';
        }
        return 'badge-warning';
    }

    showAssessmentScore(item: CurriculumItem): boolean {
        return item.content_type === 'Assessment' && item.completed && !!item.score;
    }

    getStudentFullDetail(classData: any): void {
        this.selectedClassForModal = classData;
        this.contentTypeFilter = '2';
        this.searchContent = '';
        this.refreshAssignmentRows();
        this.modalRef = this.modalService.open(this.assignmentModal, {
            size: 'xl',
            windowClass: 'reportcardContent'
        });
    }

    closeAssignmentModal(): void {
        this.modalRef?.close();
    }

    refreshAssignmentRows(): void {
        const className = this.selectedClassForModal?.class_name ?? '';
        let rows = this.assignmentDetailsByClass[className] ?? [];
        if (this.contentTypeFilter !== '0' && this.contentTypeFilter !== '2') {
            rows = [];
        }
        if (this.searchContent.trim()) {
            const q = this.searchContent.trim().toLowerCase();
            rows = rows.filter(r => r.content_name.toLowerCase().includes(q));
        }
        this.assignmentRows = rows;
    }

    onContentTypeChange(): void {
        this.refreshAssignmentRows();
    }

    onSearchContent(): void {
        this.refreshAssignmentRows();
    }
}
